export default __webpack_public_path__ + "85b91188b5bba8df25589710e14a0e89.png";